import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { locationKeySelector } from 'domain/router';
import Draggable from 'react-draggable';
import { ToastContainer, cssTransition, toast } from 'react-toastify';
import { noop } from 'lodash';
import { FormattedMessage } from 'react-intl';

import Button from '@mui/material/Button';
import { HeaderBox, ToastContainerWrapper } from './styled';

const SLIDE_TRANSITION = cssTransition({
  collapse: false,
  enter: 'Toastify--animate Toastify__zoom-enter',
  exit: 'Toastify--animate Toastify__zoom-exit',
});

const DRAGGABLE_CANCEL_SELECTOR = '.Toastify__toast, .Toastify__close-all';

const createToastChangeHandler =
  (setToastsCount) =>
  ({ status }) => {
    switch (status) {
      case 'removed':
        setToastsCount((prevCount) => prevCount - 1);
        break;
      case 'added':
        setToastsCount((prevCount) => prevCount + 1);
        break;
      default:
        break;
    }
  };

const DraggableToastContainer = (props) => {
  const locationKey = useSelector(locationKeySelector);
  const [toastsCount, setToastsCount] = useState(0);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDrag = (e, data) => {
    setPosition({ x: data.x, y: data.y });
  };

  const handleCloseAll = () => {
    toast.dismiss();
  };

  useEffect(() => {
    const handleToastChange = createToastChangeHandler(setToastsCount);

    toast.onChange(handleToastChange);
    return () => {
      toast.onChange(noop);
    };
  }, []);

  useEffect(() => {
    if (locationKey) {
      setPosition({ x: 0, y: 0 });
    }
  }, [locationKey]);

  return (
    <Draggable cancel={DRAGGABLE_CANCEL_SELECTOR} bounds="parent" position={position} onDrag={handleDrag}>
      <ToastContainerWrapper elevation={8} sx={{ display: toastsCount > 0 ? 'block' : 'none' }}>
        <HeaderBox>
          <Button className="Toastify__close-all" variant="text" size="small" onClick={handleCloseAll}>
            <FormattedMessage id="button.closeAll" defaultMessage="Close all" />
          </Button>
        </HeaderBox>
        <ToastContainer transition={SLIDE_TRANSITION} {...props} />
      </ToastContainerWrapper>
    </Draggable>
  );
};

export default DraggableToastContainer;
